import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getResales = async (page, pending) => {
  const token = await cookie.get("token");
  return await axios.post(
    `${proxy}/resales/all/${page}?pending=${pending}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};

export const searchResales = async (page, pending, search) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/resales/search?page=${page}&&pending=${pending}&&search=${search}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const resaleUpdate = async (id, body) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/resales/update?id=${id}`, body, {
    headers: { Authorization: token },
  });
};

export const getResale = async (id) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/resales/${id}`, {
    headers: { Authorization: token },
  });
};

export const getItemForResale = async (id) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/resales/items_for_admin`, {
    headers: { Authorization: token },
  });
};

export const createResale = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(
    `${proxy}/resales/create_resale_for_admin`,
    formData,
    {
      headers: { Authorization: token },
    },
  );
};

export const acceptResale = async (id) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/resales/accept?id=${id}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};

export const deleteResale = async (id) => {
  const token = await cookie.get("token");
  return await axios.delete(`${proxy}/resales/delete?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const bulkDeleteResale = async (ids) => {
  const token = await cookie.get("token");
  return await axios.post(
    `${proxy}/resales/bulk_delete`,
    { ids: ids },
    {
      headers: { Authorization: token },
    },
  );
};

export const bulkAcceptResale = async (ids) => {
  const token = await cookie.get("token");
  return await axios.post(
    `${proxy}/resales/bulk_accept`,
    { ids: ids },
    {
      headers: { Authorization: token },
    },
  );
};
